import DumaloqSvg from '@assets/icons/Dumaloq.svg'
import TeshikSvg from '@assets/icons/Diametr belgizsi.svg'
import TortburchakSvg from '@assets/icons/To`rtburchak.svg'
export default function renderServiceTypeSvg(serviceType) {
	const commonProps = {
		viewBox: '0 0 100 100',
		xmlns: 'http://www.w3.org/2000/svg',
		width: 30,
		height: 30,
	}

	switch (serviceType) {
		case 'Rombik':
			return (
				<img
					src={TortburchakSvg}
					className="!w-[30px] !h-[30px]"
					alt=""
				/>
			)
		case 'Teshik':
			return (
				<img src={TeshikSvg} className="!w-[30px] !h-[30px]" alt="" />
			)
		case 'Dumaloq':
			return (
				// <svg {...commonProps}>
				// 	<circle
				// 		cx="50"
				// 		cy="50"
				// 		r="30"
				// 		fill="#10b981"
				// 		stroke="#059669"
				// 		strokeWidth="2"
				// 	/>
				// </svg>
				<img src={DumaloqSvg} className="!w-[30px] !h-[30px]" alt="" />
			)
		default:
			return null
	}
}
